<template>
    <div class="user_content">
        <div class="user_warp">
            <div class="user_title">区域分布</div>
            <div class="user_city_nav">
                <div :class="[nCityIndex==index?'active_city_item':'']" @click="getCity(index)" v-for="(item,index) in arrCity" :key="index">{{item.name}}</div>
            </div>
            <div class="user_map">
                <div id="china_map"></div>
            </div>
            <!-- 省份表格 -->
            <div class="cityTabble">
                <div class="city_tabble_tr">
                    <div>省份</div>
                    <div>用户数</div>
                    <div>占比</div>
                </div>
                <div class="city_tabble_tr" v-for="(item,index) in arrDistributeList" :key="index">
                    <div>{{item.new_name ? item.new_name :"未知"}}</div>
                    <div>{{item.num}}</div>
                    <div>{{item.percent}}%</div>
                </div>
                <!-- <div class="city_tabble_tr">
                    <div>内蒙古自治区</div>
                    <div>96</div>
                    <div>12.66%</div>
                </div>
                <div class="city_tabble_tr">
                    <div>吉林省</div>
                    <div>1</div>
                    <div>0.13%</div>
                </div>
                <div class="city_tabble_tr">
                    <div>安徽省</div>
                    <div>1</div>
                    <div>0.13%</div>
                </div> -->
            </div>
            <el-performance :nNumber="nTotal" @next="next" @last="last" @active="getActive" :bBackfoued="false"></el-performance>
        </div>
        <div class="user_warp">
            <div class="user_title">区域分布</div>
            <div class="user_room_nav">
                <div :class="[nRoomTypeIndex==index?'active_city_item':'']" @click="getRoomType(index)" v-for="(item,index) in arrRoomType" :key="index">{{item.name}}</div>
            </div>
            <div class="user_cake">
                <div id="contribute-pie"></div>
            </div>
            <!-- 省份表格 -->
            <div class="cityTabble">
                <div class="city_tabble_tr">
                    <div>{{arrRoomType[nRoomTypeIndex].name}}</div>
                    <div>用户数</div>
                    <div>占比</div>
                </div>
                <div class="city_tabble_tr" v-for="(item,index) in arrTotalArea" :key="index">
                    <div>{{item.new_name ? item.new_name:'未知'}}</div>
                    <div>{{item.num}}</div>
                    <div>{{item.percent}}%</div>
                </div>
                <!-- <div class="city_tabble_tr">
                    <div>100平米内</div>
                    <div>54</div>
                    <div>7.12%</div>
                </div>
                <div class="city_tabble_tr">
                    <div>200平米以上</div>
                    <div>226</div>
                    <div>35.09%</div>
                </div> -->
            </div>
            <!-- <el-performance :nNumber="5" @next="next" @last="last" @active="getActive" :bBackfoued="false"></el-performance> -->
        </div>
    </div>
</template>

<script>
import elPerformance from "@/components/common/pagination/index.vue";
import oUserJs from "@/js/hvac/performance/user.js"
import { P } from '@antv/g2plot';
import { provinceGeo, cityGeo } from "@/js/hvac/performance/jsonGeo.js"
import china from 'echarts/map/json/china.json';

export default {
    created() {
        //console.log("created")
        this.getPortrayalTotalarea()
        this.getPortrayalDistributeList()
        this.getPortrayalDistribute()
        //this.initImportFile('neimenggu')
        //console.log(provinceGeo)
        //console.log(cityGeo)
        this.$echarts.registerMap('china', china)
    },
    components: {
        elPerformance,
    },
    data() {
        return {
            arrCity: [{ name: "全国" }, { name: "省" }, { name: "城市" }],
            arrRoomType: [
                { name: "面积分布" },
                { name: "房屋类型" },
                { name: "户型" },
            ],
            nCityIndex: 0,
            nRoomTypeIndex: 0,
            arrTotalArea: [],//面积分布 房屋类型 户型数据
            arrDistributeList: [],
            nTotal: 0,
            nPage: 1,
            sType: "0",
            arrMapData: [],
            sProvince: "china",
            mapChart: null,
            sAdddissid: ""//省市区ID
        };
    },
    mounted() {
        this.createContributePie();
        this.drawregionCharts();
    },
    methods: {
        drawregionCharts() {
         
            if (this.mapChart != null &&
                this.mapChart != "" &&
                this.mapChart != undefined) {
                this.mapChart.dispose();
            }
            this.mapChart = this.$echarts.init(
                document.getElementById("china_map")
            );

            let option = {
                tooltip: {
                    trigger: "item",
                    formatter: function (params) {
                        return params.name + " " + params.value;
                    },
                },
                visualMap: {
                    show: false,
                    left: 26,
                    bottom: 40,
                    showLabel: true,
                    min: 0,
                    max: 10000,
                    pieces: [
                        {
                            gte: 1000,
                            label: ">= 1000",
                            color: "#00857C",
                        },
                        {
                            gte: 100,
                            lt: 1000,
                            label: ">= 100",
                            color: "#b3eed4",
                        },
                        {
                            lt: 100,
                            label: "<100",
                            color: "#e3ffe9",
                        },
                    ],
                },
                geo: {
                    map: this.sProvince,
                    scaleLimit: {
                        min: 1,
                        max: 2,
                    },
                    zoom: 1.1,
                    top: 50,
                    label: {
                        normal: {
                            show: true,
                            fontSize: "8",
                            color: "rgba(0,0,0,0.7)",
                        },
                    },
                    itemStyle: {
                        normal: {
                            shadowBlur: 10,
                            shadowColor: "rgba(0, 0, 0, 0.2)",
                            borderColor: "rgba(0, 0, 0, 0.2)",
                        },
                        emphasis: {
                            areaColor: "#f2d5ad",
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            borderWidth: 0,
                        },
                    },
                },
                series: [
                    {
                        name: "",
                        type: "map",
                        mapType: this.sProvince,
                        geoIndex: 0,
                        data: this.arrMapData,
                    },
                ],
            };

            this.$nextTick(() => {
                this.mapChart.resize();
            });

            this.mapChart.setOption(option);

            let that = this
            this.mapChart.on('click', function (param) {
                //console.log(param)
                //判断省市
                if (param.name in provinceGeo) {
                    that.nCityIndex = 1
                    if (param.data) {
                        that.sAdddissid = param.data.id
                        that.nPage = 1
                        that.sType = 1
                        that.getPortrayalDistributeList()
                        that.getPortrayalDistribute()
                    }
                    that.initJsonGeo(param.name)
                } else if (param.name in cityGeo) {
                    that.nCityIndex = 2
                    if (param.data) {
                        that.sAdddissid = param.data.id
                        that.nPage = 1
                        that.sType = 2
                        that.getPortrayalDistributeList()
                        that.getPortrayalDistribute()
                    }
                    that.initJsonCityGeo(param.name)
                }
            })
        },
        getRoomType(index) {
            if (this.nRoomTypeIndex != index) {
                this.nRoomTypeIndex = index;
                switch (index) {
                    case 0:
                        this.getPortrayalTotalarea()
                        break
                    case 1:
                        this.getPortrayalTotalHouse()
                        break
                    case 2:
                        this.getPortrayalTotalHall()
                        break
                }
            }
        },
        getCity(index) {
            if (this.nCityIndex != index) {
                if (index == 0) {
                    this.nCityIndex = index;
                    this.sProvince = "china"
                    this.drawregionCharts()
                    this.sAdddissid = ""
                    this.nPage = 1
                    this.sType = 0
                    this.getPortrayalDistributeList()
                    this.getPortrayalDistribute()
                }
            }
        },
        // 点击页数
        getActive(val) {
            let _that = this;
            _that.nPage = val
            _that.getPortrayalDistributeList()
        },
        // 上一页
        last(val) {
            let _that = this;
            _that.nPage = val
            _that.getPortrayalDistributeList()
        },
        // 下一页
        next(val) {
            let _that = this;
            _that.nPage = val
            _that.getPortrayalDistributeList()
        },
        createContributePie() {
            let pieData = []
            this.arrTotalArea.forEach(item => {
                pieData.push({
                    name: item.new_name,
                    value: item.percent,
                })
            })

            const CHARTS = this.$echarts.init(
                document.getElementById("contribute-pie")
            );
            const OPTIONS = {
                tooltip: {
                    trigger: "item",
                },
                color: ["#5B8FF9", "#5AD8A6", "#5D7092", "#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de", "#3ba272", "#fc8452", "#9a60b4", "#ea7ccc"],
                legend: {
                    orient: 'horizontal',
                    bottom: 0,
                    itemWidth: 13,
                    itemHeight: 13,
                    icon: "circle",
                    // data: [
                    //     { name: "100-200平米", icon: "circle" },
                    //     { name: "100平米内", icon: "circle" },
                    //     { name: "200平米以上", icon: "circle" },
                    // ],
                    formatter: [
                        '{a|{name}}'
                    ].join('\n'),
                    textStyle: {
                        rich: {
                            a: {
                                color: '#858585',
                                fontSize: 13,
                                lineHeight: 13,
                            }
                        },
                    },
                },
                series: [
                    {
                        type: "pie",
                        radius: "60%",
                        center: ["50%", "45%"],
                        avoidLabelOverlap: true,
                        data: pieData,
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true,
                                    position: "outside",
                                    textStyle: {
                                        color: "#858585",
                                        fontWeight: 200,
                                        fontSize: 12,
                                    },
                                },
                                labelLine: {
                                    //指示线状态
                                    show: true,
                                    length: 10,
                                    length2: 12,
                                },
                            },
                        },
                    },
                ],
            };
            CHARTS.setOption(OPTIONS);
        },
        getPortrayalTotalarea() {
            this.$store.commit("loadSwitch", true);
            oUserJs.getPortrayalTotalarea().then(res => {
                this.$store.commit("loadSwitch", false);
                let data = res.data.data;
                this.arrTotalArea = data.result
                this.createContributePie()
            })
        },
        getPortrayalTotalHouse() {
            this.$store.commit("loadSwitch", true);
            oUserJs.getPortrayalTotalHouse().then(res => {
                this.$store.commit("loadSwitch", false);
                let data = res.data.data;
                this.arrTotalArea = data.result
                this.createContributePie()
            })
        },
        getPortrayalTotalHall() {
            this.$store.commit("loadSwitch", true);
            oUserJs.getPortrayalTotalHall().then(res => {
                this.$store.commit("loadSwitch", false);
                let data = res.data.data;
                this.arrTotalArea = data.result
                this.arrTotalArea.forEach(item => {
                    if (item.new_name) {
                        item.new_name = item.new_name + "厅"
                    } else {
                        item.new_name = "其他"
                    }
                })
                this.createContributePie()
            })
        },
        getPortrayalDistributeList() {
            this.$store.commit("loadSwitch", true);
            oUserJs.getPortrayalDistributeList({ adddissid: this.sAdddissid, type: this.sType, page: this.nPage, size: 10 }).then(res => {
                this.$store.commit("loadSwitch", false);
                let data = res.data.data;
                this.arrDistributeList = data.result.list
                this.nTotal = Number(data.result.page)
                //console.log(this.nTotal)
            })
        },
        getPortrayalDistribute() {
            this.$store.commit("loadSwitch", true);
            oUserJs.getPortrayalDistribute({ adddissid: this.sAdddissid, type: this.sType }).then(res => {
                this.$store.commit("loadSwitch", false);
                let data = res.data.data;
                //console.log(data)
                this.arrMapData = []
                data.result.forEach(item => {
                    this.arrMapData.push({
                        id: item.adddissid,
                        name: item.new_name,
                        value: Number(item.num)
                    })
                    this.arrMapData.push({ name: "南海诸岛", value: 0 })
                });
                //console.log(this.arrMapData)
                this.drawregionCharts()
            })
        },
        initJsonGeo(val) {
            let that = this
            that.sProvince = provinceGeo[val]
            that.$http.get('https://pro-core.babycdn.com/2021/aosmith/vuetest/map/province/' + that.sProvince + '.json').then((obj) => {
                that.$echarts.registerMap(that.sProvince, obj.data);
                console.log(that.sProvince, obj.data)
                that.drawregionCharts()

            })
        },
        initJsonCityGeo(val) {
            let that = this
            if (cityGeo[val]) {
                that.sProvince = cityGeo[val]
                that.$http.get('https://pro-core.babycdn.com/2021/aosmith/vuetest/map/city/' + that.sProvince + '.json').then((obj) => {
                    that.$echarts.registerMap(that.sProvince, obj.data);
                    //console.log(that.sProvince, obj.data)
                    that.drawregionCharts()
                })
            }
        }
    },
};
</script>
<style lang="scss" scoped>
.user_content {
    height: 100%;
    padding: 24px;
    box-sizing: border-box;
    .user_warp {
        width: 100%;
        background: #fff;
        border-radius: 12px;
        padding: 18px 18px;
        box-sizing: border-box;
        &:last-child {
            margin-top: 24px;
        }
        .user_title {
            font-size: 28px;
            font-weight: 700;
            color: #222222;
        }
        .user_room_nav {
            width: 80%;
            display: flex;
            margin: 28px auto;
            border-radius: 12px;
            overflow: hidden;
            border: 1px solid $deepGreen;
            div {
                width: 33.33%;
                font-size: 28px;
                padding: 10px 0;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: center;
                &:nth-child(2) {
                    border-left: 1px solid $deepGreen;
                    border-right: 1px solid $deepGreen;
                }
            }
            .active_city_item {
                background: $deepGreen;
                color: #fff;
            }
        }
        .user_city_nav {
            width: 50%;
            display: flex;
            margin: 28px auto;
            border-radius: 12px;
            overflow: hidden;
            border: 1px solid $deepGreen;
            div {
                width: 33.33%;
                font-size: 28px;
                padding: 10px 0;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: center;
                &:nth-child(2) {
                    border-left: 1px solid $deepGreen;
                    border-right: 1px solid $deepGreen;
                }
            }
            .active_city_item {
                background: $deepGreen;
                color: #fff;
            }
        }
        .user_map {
            width: 100%;
            height: 648px;
            margin-top: 41px;
            #china_map {
                width: 100%;
                height: 648px;
            }
        }
        .user_cake {
            width: 100%;
            height: 480px;
            margin-top: 41px;
            #contribute-pie {
                width: 100%;
                height: 480px;
            }
        }
        .cityTabble {
            width: 100%;
            margin-bottom: 20px;
            .city_tabble_tr {
                width: 100%;
                display: flex;
                align-items: center;
                height: 82px;
                border-bottom: 1px dashed #f1f1f1;
                &:first-child {
                    border: 0;
                    div {
                        color: #a2a2a2;
                        font-size: 28px;
                    }
                }
                div {
                    color: #444444;
                    font-size: 28px;
                    &:nth-child(1) {
                        width: 40%;
                    }
                    &:nth-child(2) {
                        text-align: center;
                        width: 30%;
                    }
                    &:nth-child(3) {
                        width: 30%;
                        text-align: center;
                    }
                }
            }
        }
    }
}
</style>
